import Vue from 'vue';
import Router from 'vue-router';
// 权限模块路由
import systemRouter from '@/interview/pages/system/router';
import powerRouter from '@/interview/pages/power/router';
import globalRouter from './global';

const Login = () => import('../interview/pages/Login.vue');
const homepage = () => import('@/interview/pages/home');
const tablepage = () => import('@/interview/pages/Table');
const intertc = () => import('@/interview/pages/RTC');


Vue.use(Router);

const router = new Router({
  mode: 'history',
});

/* eslint-disable object-property-newline */
router.addRoutes([
  {
    path: '/', name: 'homepage', component: homepage, meta: { c: 'index', a: 'index' },
  },
  {
    path: '/table/:crm_id', name: 'tablepage', component: tablepage, meta: { noLayout: true, c: 'index', a: 'index' },
  },
  {
    path: '/rtc/:inter_id&:way', name: 'intertc', component: intertc, meta: { noLayout: true, c: 'index', a: 'index' },
  },
  {
    path: '/interviewee/list', name: 'interviewer_list', component: homepage, meta: { c: 'interviewee', a: 'list' },
  },
  {
    path: '/login', name: 'login', component: Login, meta: { noLayout: true, noAuth: true }
  },
  {
    path: '/account', name: 'account', redirect: { path: '/' },
  },
  {
    path: '/wait_sent', name: 'wait_sent', component: homepage, meta: { c: 'index', a: 'wait_sent' }
  }
]);

router.addRoutes(systemRouter);
router.addRoutes(powerRouter);
router.addRoutes(globalRouter);

router.addRoutes([{
  path: '*', name: '404', component: {
    template: '<p>Page Not Found</p>'
  }
}]);

export default router;
